import {
  createPrivacyPolicy,
  deletePrivacyPolicy,
  getAllConfTexts,
  getPrivacyPolicyById,
  updatePrivacyPolicy,
} from "@/api/privacy-policy/privacy-policy-services";

export const privacyPolicySlice = (set, get) => ({
  privacyPolicies: [],
  updateModal: false,
  policyToUpdate: {},

  getPrivacyPolicies: async () => {
    const data = await getAllConfTexts();
    set({ privacyPolicies: data });
  },

  createPrivacyPolicy: async (policy) => {
    await createPrivacyPolicy(policy);
    await get().getPrivacyPolicies();
  },

  deletePrivacyPolicy: async (id) => {
    await deletePrivacyPolicy(id);
    await get().getPrivacyPolicies();
  },

  setUpdateModal: (value) => {
    set((state) => ({
      updateModal: value,
      policyToUpdate: value ? state.policyToUpdate : {},
    }));
  },

  getPolicyToUpdate: async (id) => {
    const data = await getPrivacyPolicyById(id);
    set({ policyToUpdate: data });
    return data;
  },

  updatePrivacyPolicy: async (id, policy) => {
    await updatePrivacyPolicy(id, policy);
    await get().getPrivacyPolicies();
  },
});
